import { render } from "./VideoController2.vue?vue&type=template&id=278d57b9&scoped=true"
import script from "./VideoController2.vue?vue&type=script&lang=js"
export * from "./VideoController2.vue?vue&type=script&lang=js"

import "./VideoController2.vue?vue&type=style&index=0&id=278d57b9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278d57b9"]])

export default __exports__